export function daysFromNow(numberOfDays, date = new Date()) {
    return new Date(date.setDate(date.getDate() + numberOfDays));
}